var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 64,
    viewBox: "0 0 94 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3333 22.7958C78.3333 22.2083 78.3333 21.8166 78.3333 21.2291C78.3333 9.87079 69.1292 0.666626 57.7708 0.666626C48.9583 0.666626 41.3209 6.34578 38.5792 14.1791C36.425 13.0041 34.075 12.4166 31.3333 12.4166C22.7167 12.4166 15.6667 19.4666 15.6667 28.0833C15.6667 28.6708 15.6667 29.4541 15.8625 30.0416H15.6667C6.85417 30.6291 0 37.6791 0 46.6875C0 55.5 6.85417 62.7458 15.6667 63.3333H74.4167C85.3833 62.7458 94 53.9333 94 42.7708C94 32.9791 87.3417 24.9499 78.3333 22.7958ZM52.875 53.5416H41.125L44.65 41.3999C41.5166 40.4208 39.1667 37.4833 39.1667 33.9583C39.1667 29.65 42.6917 26.125 47 26.125C51.3083 26.125 54.8333 29.65 54.8333 33.9583C54.8333 37.4833 52.4833 40.4208 49.35 41.3999L52.875 53.5416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.e14a3759cead008ea6096352d34a9229.svg";
export { ForwardRef as ReactComponent };